// extracted by mini-css-extract-plugin
module.exports = {"baseSticky":"BaseSticky_baseSticky_3upKB"};